import styled from 'styled-components';
import { withRouter, Link, useHistory } from 'react-router-dom';

import TourImageDescriptionMinized from '@/components/ticketingNew/components/TourImageDescriptionMinized';
import StepsBlock from '@/components/ticketingNew/components/StepsBlock';
import TicketingButton, { ETickBtnType } from '@/components/ticketingNew/components/TicketingButton';

import { useRecoilValue, orderedTicketsState, translationDataState } from '../../../store';
import { toast } from 'react-toastify';

const MainWrap = styled.div<{ minimized: boolean }>`
  ${(p) => (p.minimized ? 'color:initial;' : '')}
  .bl-success-block-wrap {
    background: #ffffff;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    width: 570px;
    margin: auto;
    margin-top: 48px;
    padding: 71px 37px 38px 37px;
    position: relative;
    text-align: center;

    .bl-success-block-triangle {
      width: 0;
      height: 0;
      border-top: 108px solid #ea475c;
      border-right: 171px solid transparent;
      position: absolute;
      top: 0;
      left: 0;
    }

    .bl-success-block-ok-sign {
      width: 71px;
      height: 71px;
      background-color: #ea475c;
      border-radius: 50%;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 45px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
      margin-bottom: 20px;
    }

    .bl-success-block-title {
      font-weight: 500;
      font-size: 30px;
      line-height: 45px;
      margin-bottom: 20px;
    }

    .bl-success-block-text {
      font-weight: 400;
      font-size: 18px;
      line-height: 130.3%;
      margin-bottom: 38px;
    }

    .bl-success-btns {
      justify-content: space-between;
      display: flex;
      margin: auto;
      margin-bottom: 40px;
      width: 426px;

      a {
        text-decoration: initial;
      }

      button {
        min-width: 202px;
      }
    }

    .bl-success-block-safety {
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: baseline;

      .bl-success-block-safety-icon {
        margin: 0 10px;
        border: 1px solid black;
        border-radius: 50%;
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  @media screen and (max-width: 760px) {
    .bl-success-block-wrap {
      display: flex;
      flex-direction: column;
      max-width: calc(100% - 30px);
      margin-left: 15px;
      margin-right: 15px;
      padding-top: 36px;
      padding-bottom: 28px;

      .bl-success-block-triangle {
        border-top: 73px solid #ea475c;
        border-right: 116px solid transparent;
      }

      .bl-success-block-ok-sign {
        order: 1;
      }

      .bl-success-block-title {
        order: 0;
      }

      .bl-success-block-text {
        order: 3;
      }

      .bl-success-block-safety {
        order: 4;
      }

      .bl-success-block-safety-icon {
        min-width: 28px;
      }

      .bl-success-btns {
        order: 4;
        flex-wrap: wrap;
        justify-content: center;

        button {
          width: 100%;
        }

        button:first-child {
          margin-bottom: 15px;
        }
      }
    }
  }
`;

const OrderSuccess = (props: any) => {
  const { location, minimized = false, onLinkClick = () => {} } = props;
  const ticketsRes = useRecoilValue(orderedTicketsState);
  const history = useHistory();
  console.log('ticketsRes success page', ticketsRes);
  let firstTicket;
  let firstTicketCode;
  if (ticketsRes) {
    firstTicket = ticketsRes?.tickets?.find((t) => t.code);
    firstTicketCode = firstTicket?.code;
  }
  const bookPage = location.pathname.replace(/book.+|book/g, '') + 'book';
  if (!firstTicket) {
    toast.error('No ticket found, redirecting to home page');
    return history.push(bookPage);
  }
  const loginPage = location.pathname.replace(/book.+|book/g, '') + `login?ticket=${firstTicketCode}`;

  if (firstTicket.type === 'gameTour' && ticketsRes.gameId) loginPage.replace('/tour/', `/experience/${ticketsRes.gameId}/`);

  const {
    payment_confirmed = 'Payment cofirmed',
    full_transaction_details = 'The full transaction details will be sending to your Email',
    protect_message = 'We protect your payment information using encryption to provide bank-level security.',
  } = useRecoilValue(translationDataState);

  return (
    <MainWrap minimized={minimized}>
      {!minimized && <TourImageDescriptionMinized />}
      {!minimized && <StepsBlock count={3} active={3} done={[1, 2]} />}
      <div className="bl-success-block-wrap">
        <div className="bl-success-block-triangle" />
        <div className="bl-success-block-ok-sign">
          <i className="far fa-check" />
        </div>
        <div className="bl-success-block-title">{payment_confirmed}</div>
        <div className="bl-success-block-text">{full_transaction_details}</div>
        <div className="bl-success-btns">
          <Link to={bookPage} onClick={onLinkClick}>
            <TicketingButton text="Book More Tours" type={ETickBtnType.white} />
          </Link>
          {firstTicketCode && (
            <Link to={loginPage} onClick={onLinkClick}>
              <TicketingButton text="Start Tour Now" />
            </Link>
          )}
        </div>
        <div className="bl-success-block-safety">
          <div className="bl-success-block-safety-icon">
            <i className="fas fa-lock" />
          </div>
          {protect_message}
        </div>
      </div>
    </MainWrap>
  );
};

export default withRouter(OrderSuccess);
